const MarginSection = () => {
  return (
    <section>
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-6">
              <div className="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">Margins <span></span></h2>
                  <p className="mb-0">
                    Exchanges mandate margins on exposures taken in the markets. A brief write-up on the various margins
                    both in cash and futures is given below. For more specific details, visit the exchange site in
                    question. <a href="https://www.nseindia.com/" target="_blank" rel="noopener noreferrer"></a> https://www.nseindia.com/
                  </p>
                  <h4 className="meet-oppurtanity">Cash Market :</h4>
                  <p className="mb-0">Daily margin, comprising the sum of VaR margin, Extreme Loss Margin and mark to market
                    margin is payable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarginSection;